export enum TipoDocumentoFiscalEnum {

  NF = "Nota Fiscal",
  RECIBO = "Recibo"
}
